module.exports = __webpack_public_path__ + "static/media/vivian-hunt.34f7b67a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vivian-hunt.jpg
// module id = 1126
// module chunks = 0